import React, { useEffect, useState } from "react";
import DataTable from "mui-datatables";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { TableOptions } from "../../config/Table";
import { _TableLoader } from "..";
import { GetTendersDatabaseColumns } from "./TendersDatabaseColumns";

interface ITendersDatabaseProps {
    CIG: string;
    UseTendersDatabase: (data: Dati.CBancaDatiGare) => void;
}

const useStyles = makeStyles(({ shape, spacing }: Theme) => ({
    title: {
    },
    toolbar: {
        borderRadius: shape.borderRadius,
        marginTop: spacing(4),
        marginBottom: spacing(2)
    },
    tableWrapper: {
        position: "relative"
    }
}));

export const _TendersDatabase: React.FC<ITendersDatabaseProps> = ({ CIG, UseTendersDatabase }) => {
    const classes = useStyles();

    const [IsLoading, setIsLoading] = useState(false);
    const [Data, setData] = useState<any>(undefined);

    useEffect(() => {
        GetData();
    }, [CIG]);

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/BancaDatiGare/Ricerca?CIG=${CIG}`,
            Metodo: "GET",
            OnRis: OnGetData,
            OnErrore: OnError
        };
        setIsLoading(true);
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, dati: any) => {
        setData(dati);
        setIsLoading(false);
    };

    const OnError = (sender: ChiamaWeb, errore: Error) => {
        setIsLoading(false);
    };

    const Options = {
        ...TableOptions,
        pagination: false,
        textLabels: {
            body: {
                noMatch: Trad.Trad("Nessun record corrisponde ai parametri di ricerca"),
                toolTip: Trad.Trad("Ordina")
            }
        }
    };

    return (
        <>
            <Toolbar variant="dense" className={`${classes.toolbar} info`}>
                <Typography variant="subtitle1" color="inherit" className={classes.title}>
                    {Trad.Trad("BancaDatiGare")}
                </Typography>
            </Toolbar>
            <Box className={classes.tableWrapper}>
                {IsLoading && <_TableLoader />}
                <DataTable title="" data={Data?.Dati || []} columns={GetTendersDatabaseColumns(UseTendersDatabase)} options={Options} />
            </Box>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/TendersDatabase.tsx